import React from "react"
import PropTypes from "prop-types"
import "./Loader.css"

function Loader({ logo }) {
  return <div className={logo && logo ? "Loader withLogo" : "Loader only"} />
}

Loader.propTypes = {
  logo: PropTypes.bool
}

Loader.defaultProps = {
  logo: false
}

export default React.memo(Loader)
